import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJenkinsLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 54,
	height: 55,
	viewBox: "0 0 54 55",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_113679_682)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M46.174 26.0464C46.174 36.7451 37.5896 45.4182 27.0002 45.4182C16.411 45.4182 7.82666 36.7451 7.82666 26.0464C7.82666 15.3474 16.411 6.67418 27.0002 6.67418C37.5896 6.67418 46.174 15.3474 46.174 26.0464Z",
					fill: "#D33833"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.60816 30.8442C8.60816 30.8442 7.22012 10.6426 26.0653 10.0653L24.7506 7.90086L14.5246 11.2919L11.6029 14.6107L9.04642 19.4448L7.58545 25.0725L8.02371 28.8241",
					fill: "#EF3D3A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.868 12.8312C10.5039 16.2311 8.42221 20.9254 8.42221 26.1186C8.42221 31.3108 10.5039 36.0057 13.868 39.405C17.2337 42.8043 21.8721 44.9019 27 44.9019C32.1281 44.9019 36.7669 42.8043 40.1322 39.405C43.4961 36.0057 45.5782 31.3108 45.5782 26.1186C45.5782 20.9254 43.4961 16.2311 40.1322 12.8312C36.7669 9.43254 32.1281 7.33495 27 7.33451C21.8721 7.33495 17.2337 9.43254 13.868 12.8312ZM13.0165 40.2273C9.44124 36.6157 7.23096 31.6244 7.23096 26.1186C7.23096 20.612 9.44124 15.6212 13.0165 12.0093C16.5908 8.39684 21.5387 6.1577 27 6.15834C32.4614 6.1577 37.4098 8.39684 40.9835 12.0093C44.5591 15.6212 46.7696 20.6125 46.7692 26.1186C46.7696 31.6244 44.5591 36.6157 40.9835 40.2273C37.4098 43.8396 32.4614 46.0785 27 46.0785C21.5387 46.0785 16.5908 43.8396 13.0165 40.2273Z",
					fill: "#231F20"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M35.0713 26.1537L32.1494 26.5866L28.2051 27.0195L25.6485 27.0916L23.1651 27.0195L21.2659 26.4422L19.5859 24.6386L18.2711 20.959L17.979 20.1653L16.2259 19.5882L15.2033 17.9287L14.4729 15.5478L15.2765 13.4554L17.1755 12.8061L18.7094 13.5277L19.4399 15.1149L20.3164 14.9705L20.6085 14.6099L20.3164 12.9504L20.2433 10.858L20.6815 7.97215L20.6644 6.32369L21.9963 4.22048L24.3337 2.56098L28.4242 0.8294L32.9528 1.47874L36.8971 4.29255L38.7233 7.17844L39.8919 9.27083L40.184 14.4656L39.3075 18.9389L37.7006 22.907L36.1667 24.9994",
					fill: "#F0D6B7"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M32.5876 38.6354L22.1423 39.0683V40.7999L23.0189 46.8604L22.5806 47.3656L15.2764 44.9124L14.765 44.0466L14.0346 35.8939L12.3548 30.9877L11.9895 29.8334L17.8328 25.8653L19.659 25.1436L21.2658 27.0917L22.6536 28.3183L24.2607 28.8232L24.991 29.0397L25.8675 32.7914L26.5249 33.585L28.205 33.0078L27.0362 35.2446L33.391 38.2025L32.5876 38.6354Z",
					fill: "#335061"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M15.2767 13.4555L17.1757 12.8062L18.7096 13.5278L19.4401 15.115L20.3166 14.9706L20.5358 14.1048L20.0975 12.4456L20.5358 8.47722L20.1704 6.31275L21.4852 4.79762L24.3339 2.56107L23.5304 1.47884L19.5131 3.42686L17.833 4.72554L16.8835 6.74564L15.4226 8.69366L14.9844 11.0025L15.2767 13.4555Z",
					fill: "#6D6B6D"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M18.2714 6.6735C18.2714 6.6735 19.367 4.00406 23.7496 2.70538C28.1322 1.4067 23.9687 1.7673 23.9687 1.7673L19.2211 3.57117L17.3949 5.37482L16.5916 6.81787L18.2714 6.6735Z",
					fill: "#DCD9D8"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M16.08 12.9504C16.08 12.9504 14.5461 7.89978 20.3896 7.17836L20.1704 6.31258L16.1532 7.25066L14.9844 11.0023L15.2767 13.4553L16.08 12.9504Z",
					fill: "#DCD9D8"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M18.4175 19.6603L19.3739 18.7449C19.3739 18.7449 19.8055 18.7945 19.8785 19.2994C19.9514 19.8046 20.1705 24.35 23.3113 26.8032C23.5978 27.027 20.9741 26.4422 20.9741 26.4422L18.6366 22.8349",
					fill: "#F7E4CD"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M31.8576 18.2897C31.8576 18.2897 32.0279 16.1027 32.6241 16.2709C33.2204 16.4391 33.2204 17.028 33.2204 17.028C33.2204 17.028 31.7724 17.9533 31.8576 18.2897Z",
					fill: "#F7E4CD"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M37.92 10.281C37.92 10.281 36.7161 10.532 36.6053 11.5796C36.4944 12.6275 37.92 11.7961 38.1392 11.724",
					fill: "#F7E4CD"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M29.0817 10.3534C29.0817 10.3534 27.4746 10.5698 27.4746 11.5797C27.4746 12.5899 29.3009 12.5178 29.8121 12.0849",
					fill: "#F7E4CD"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M19.1475 15.0429C19.1475 15.0429 16.3718 13.3834 16.0797 14.9708C15.7876 16.558 15.13 17.7125 16.518 19.3718L15.5685 19.0833L14.692 16.8468L14.3999 14.6823L16.0797 12.9505L17.9789 13.0949L19.0745 13.9607L19.1475 15.0429Z",
					fill: "#F7E4CD"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M20.4627 10.4974C20.4627 10.4974 21.7044 4.1484 27.9862 2.9218C33.1579 1.91207 35.8747 3.13824 36.8973 4.29255C36.8973 4.29255 32.2956 -1.1184 27.913 0.54088C23.5305 2.20038 20.3167 5.23063 20.3896 7.17844C20.514 10.4961 20.4627 10.4974 20.4627 10.4974Z",
					fill: "#F7E4CD"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M37.4088 5.01398C37.4088 5.01398 35.2907 4.9419 35.2175 6.81785C35.2175 6.81785 35.2173 7.10637 35.3635 7.3949C35.3635 7.3949 37.0437 5.51895 38.0662 6.52911",
					fill: "#F7E4CD"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M28.1332 7.59026C28.1332 7.59026 27.7686 4.71087 25.2833 6.38487C23.6764 7.4671 23.8226 8.98223 24.1146 9.27075C24.4068 9.55949 24.3273 10.1407 24.5497 9.74174C24.772 9.34283 24.6988 8.04415 25.5024 7.68355C26.3059 7.32273 27.6231 6.91971 28.1332 7.59026Z",
					fill: "#F7E4CD"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M21.2658 27.0916L14.3999 30.1219C14.3999 30.1219 17.2486 41.305 15.7876 44.7682L14.765 44.4076L14.692 40.1507L12.7931 32.0701L11.9895 29.8334L19.1476 25.0717L21.2658 27.0916Z",
					fill: "#49728B"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M21.972 33.277L22.9461 34.451V38.7799H21.7773C21.7773 38.7799 21.6313 35.7497 21.6313 35.3888C21.6313 35.028 21.7773 33.7293 21.7773 33.7293",
					fill: "#49728B"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M21.9962 39.4294L18.7092 39.5735L19.6589 40.2228L21.9962 40.5836",
					fill: "#49728B"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M33.2451 38.7077L35.9476 38.6356L36.605 45.2734L33.8293 45.634L33.2451 38.7077Z",
					fill: "#335061"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M33.9756 38.7075L38.0661 38.4911C38.0661 38.4911 39.7459 34.3065 39.7459 34.09C39.7459 33.8736 41.2068 28.0295 41.2068 28.0295L37.9199 24.6387L37.2625 24.0614L35.5095 25.793V32.5029L33.9756 38.7075Z",
					fill: "#335061"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M35.8015 38.2026L33.2451 38.7076L33.6102 40.728C34.5597 41.1608 36.1668 40.0063 36.1668 40.0063",
					fill: "#49728B"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M35.875 25.5767L40.9879 29.3284L41.1341 27.5968L37.2627 24.0616L35.875 25.5767Z",
					fill: "#49728B"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M24.5311 52.9216L23.0188 46.8602L22.2667 42.3878L22.1423 39.0681L28.9868 38.7082L33.245 38.7075L32.8578 46.2839L33.5152 52.1279L33.4422 53.2102L27.8911 53.6431L24.5311 52.9216Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M32.2954 38.6355C32.2954 38.6355 31.9303 46.1391 33.0259 51.478C33.0259 51.478 30.8347 52.849 27.6206 53.2096L33.7563 52.9931L34.4866 52.5603L33.6101 40.728L33.391 38.2025",
					fill: "#DCD9D8"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M36.7298 44.6967L39.5785 43.903L44.9835 43.6144L45.7871 41.1614L44.3262 36.9046L42.6463 36.6881L40.3089 37.4096L38.0663 38.4911L36.8758 38.2754L35.948 38.6354",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M36.678 43.2531C36.678 43.2531 38.5769 42.3874 38.8693 42.4596L38.0659 38.4912L39.0154 38.1306C39.0154 38.1306 39.6728 41.8823 39.6728 42.3152C39.6728 42.3152 43.7631 42.5316 44.1283 42.5316C44.1283 42.5316 45.0049 40.8721 44.7857 39.1406L45.5893 41.4494L45.6622 42.748L44.4936 44.4796L43.1789 44.7682L40.9876 44.6961L40.2572 43.7582L37.7007 44.1188L36.8971 44.4076",
					fill: "#DCD9D8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M33.8077 38.1313L32.2008 34.0909L30.5208 31.71C30.5208 31.71 30.8858 30.6998 31.3973 30.6998C31.9087 30.6998 33.0773 30.6998 33.0773 30.6998L34.6842 31.2771L34.5383 33.9466L33.8077 38.1313Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M34.1219 36.7597C34.1219 36.7597 32.0766 32.8638 32.0766 32.2866C32.0766 32.2866 32.4416 31.4208 32.9531 31.6373C33.4645 31.8537 34.5602 32.4308 34.5602 32.4308V31.06L32.0766 30.5548L30.3967 30.7713L33.2454 37.409L33.8296 37.4813",
					fill: "#DCD9D8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.1889 27.2369L23.1653 27.0196L21.2661 26.4423V27.0916L22.1941 28.1024L25.1158 29.4011",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M21.9237 27.4531C21.9237 27.4531 24.1882 28.3912 24.9186 28.1748L24.9913 29.0397L22.9464 28.6076L21.7046 27.7419L21.9237 27.4531Z",
					fill: "#DCD9D8"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M36.7218 30.9454C35.4824 30.9095 34.3627 30.7641 33.3823 30.4909C33.4489 30.0939 33.3242 29.7043 33.4244 29.4184C33.6976 29.224 34.1556 29.2271 34.5687 29.1814C34.2115 29.008 33.7097 28.9394 33.2975 29.0396C33.2879 28.7641 33.1627 28.5933 33.0869 28.3777C33.7837 28.1321 35.4287 26.5215 36.3541 27.0548C36.795 27.3085 36.9824 28.7574 37.0165 29.4619C37.045 30.0463 36.9629 30.6359 36.7218 30.9454Z",
					fill: "#D33833"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M36.7218 30.9454C35.4824 30.9095 34.3627 30.7641 33.3823 30.4909C33.4489 30.0939 33.3242 29.7043 33.4244 29.4184C33.6976 29.224 34.1556 29.2271 34.5687 29.1814C34.2115 29.008 33.7097 28.9394 33.2975 29.0396C33.2879 28.7641 33.1627 28.5933 33.0869 28.3777C33.7837 28.1321 35.4287 26.5215 36.3541 27.0548C36.795 27.3085 36.9824 28.7574 37.0165 29.4619C37.045 30.0463 36.9629 30.6359 36.7218 30.9454Z",
					stroke: "#D33833",
					strokeWidth: 2.16198
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M30.7951 28.9443C30.7918 29.0369 30.7878 29.1302 30.7841 29.2237C30.3971 29.4748 29.7724 29.4717 29.3477 29.6828C29.9738 29.7098 30.4666 29.8588 30.893 30.0687C30.8836 30.302 30.8746 30.5351 30.8654 30.7685C30.1561 31.2481 29.5081 31.9624 28.673 32.4122C28.2781 32.6249 26.8923 33.1723 26.4722 33.0756C26.2345 33.021 26.2131 32.7297 26.1181 32.4551C25.9156 31.8669 25.4496 30.9308 25.4089 30.0455C25.3571 28.9274 25.2428 27.0534 26.4628 27.2837C27.447 27.4692 28.5917 27.917 29.3536 28.3283C29.8193 28.5798 30.0886 28.8906 30.7951 28.9443Z",
					fill: "#D33833"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M30.7951 28.9443C30.7918 29.0369 30.7878 29.1302 30.7841 29.2237C30.3971 29.4748 29.7724 29.4717 29.3477 29.6828C29.9738 29.7098 30.4666 29.8588 30.893 30.0687C30.8836 30.302 30.8746 30.5351 30.8654 30.7685C30.1561 31.2481 29.5081 31.9624 28.673 32.4122C28.2781 32.6249 26.8923 33.1723 26.4722 33.0756C26.2345 33.021 26.2131 32.7297 26.1181 32.4551C25.9156 31.8669 25.4496 30.9308 25.4089 30.0455C25.3571 28.9274 25.2428 27.0534 26.4628 27.2837C27.447 27.4692 28.5917 27.917 29.3536 28.3283C29.8193 28.5798 30.0886 28.8906 30.7951 28.9443Z",
					stroke: "#D33833",
					strokeWidth: 2.16198
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M31.4996 30.2782C31.3914 29.6691 31.2663 29.4953 31.3147 28.9639C32.9592 27.8808 33.268 30.8243 31.4996 30.2782Z",
					fill: "#D33833"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M31.4996 30.2782C31.3914 29.6691 31.2663 29.4953 31.3147 28.9639C32.9592 27.8808 33.268 30.8243 31.4996 30.2782Z",
					stroke: "#D33833",
					strokeWidth: 2.16198
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M33.8808 30.7721C33.8808 30.7721 33.3694 30.0505 33.7347 29.834C34.1 29.6176 34.4652 29.8342 34.6844 29.4734C34.9035 29.1126 34.6844 28.8961 34.7573 28.4633C34.8303 28.0304 35.1958 27.9581 35.5609 27.886C35.926 27.8139 36.9488 27.6695 37.0948 28.0304L36.6565 26.7317L35.78 26.4432L33.0043 28.0304L32.8582 28.8241V30.4113",
					fill: "#EF3D3A"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M26.2114 33.153C26.1237 32.027 26.0308 30.9025 25.9275 29.7777C25.7729 28.098 26.336 28.3911 27.81 28.3911C28.0351 28.3911 29.1961 28.6562 29.2792 28.824C29.6776 29.6277 28.613 29.4491 29.738 30.0551C30.6877 30.5666 32.3654 29.7445 31.9817 28.6075C31.767 28.3547 30.8628 28.5288 30.5387 28.3627C29.9681 28.0705 29.3975 27.7783 28.8268 27.4861C28.1008 27.1141 26.4229 26.5716 25.6488 27.0916C23.6875 28.4091 25.7726 31.701 26.4722 33.0754",
					fill: "#EF3D3A"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M28.1333 7.59034C26.1424 7.13234 25.1532 8.41327 24.5497 9.74182C24.0109 9.61282 24.2253 8.88902 24.3614 8.5202C24.7178 7.55225 26.1538 6.26373 27.3272 6.43841C27.8321 6.51351 28.5154 6.96957 28.1333 7.59034Z",
					fill: "#231F20"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M37.8337 9.82967C37.865 9.83097 37.8968 9.83205 37.9281 9.83335C38.378 10.7565 38.7674 11.7344 39.3349 12.5493C38.9547 13.424 36.456 14.198 36.4946 12.6275C37.035 12.3941 37.9678 12.5798 38.4468 12.2818C38.1698 11.5309 37.7701 10.8918 37.8337 9.82967Z",
					fill: "#231F20"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M29.1527 9.85381C29.5796 10.6267 29.7185 11.4388 30.3253 12.023C30.5985 12.286 31.1299 12.6066 30.8665 13.338C30.8049 13.5105 30.3551 13.8951 30.0954 13.9706C29.1468 14.2472 26.9364 14.0278 27.6849 12.8596C28.4694 12.8958 29.5239 13.3628 30.1103 12.8003C29.66 12.0893 28.8572 10.6826 29.1527 9.85381Z",
					fill: "#231F20"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M37.4773 17.7094C36.049 18.6156 34.4564 19.6011 32.1161 19.3726C31.616 18.9431 31.4254 17.9875 31.9112 17.3564C32.164 17.7858 32.0052 18.5756 32.7099 18.6944C34.0378 18.9189 35.5833 17.8921 36.5385 17.5332C37.1308 16.5468 36.4875 16.1841 35.9539 15.5492C34.8615 14.2486 33.3962 12.6365 33.4495 10.6894C33.891 10.3731 33.9291 11.172 33.9925 11.3175C34.5628 12.6361 35.9984 14.3224 37.046 15.451C37.3033 15.7289 37.7268 15.9956 37.774 16.1793C37.9098 16.7137 37.4205 17.354 37.4773 17.7094Z",
					fill: "#231F20"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M18.6476 16.7553C18.2 16.5029 18.0934 15.3912 17.5678 15.3596C16.8167 15.3146 16.9537 16.8018 16.9567 17.6715C16.4397 17.2079 16.3487 15.7804 16.7286 15.0473C16.2957 14.8374 16.1024 15.2789 15.8623 15.4345C16.1709 13.2203 19.1415 14.4075 18.6476 16.7553Z",
					fill: "#231F20"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M38.3866 18.6315C37.7218 19.8815 36.7813 21.2581 34.8304 21.2981C34.7907 20.8944 34.7602 20.2801 34.8326 20.0371C36.3239 19.8955 37.2447 19.1457 38.3866 18.6315Z",
					fill: "#231F20"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M29.0403 19.4418C30.2846 20.0881 32.5714 20.1576 34.2626 20.1087C34.3534 20.4747 34.3512 20.9269 34.3547 21.3732C32.1807 21.4803 29.6103 20.949 29.0403 19.4418Z",
					fill: "#231F20"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M28.8035 20.6471C29.664 22.781 32.6213 22.5354 35.1152 22.4765C35.0054 22.7536 34.7675 23.0808 34.4716 23.1992C33.6725 23.5204 31.4683 23.7642 30.3588 23.1821C29.6552 22.8127 29.2031 21.9778 28.8176 21.4884C28.6314 21.2521 27.7044 20.6484 28.8035 20.6471Z",
					fill: "#231F20"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M37.3733 32.4181C36.3636 34.1263 35.3974 35.8808 34.1995 37.3876C34.7017 35.9289 34.9167 33.4875 34.9925 31.6264C36.0432 31.1407 36.943 31.7357 37.3733 32.4181Z",
					fill: "#81B0C4"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M42.8068 38.5577C41.6763 38.7812 40.8819 39.8665 39.7791 39.7968C40.3852 38.9528 41.4473 38.5971 42.8068 38.5577Z",
					fill: "#231F20"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M43.3055 40.3052C42.384 40.4013 41.3018 40.5487 40.3672 40.4728C40.8096 39.8053 42.5142 40.0356 43.3055 40.3052Z",
					fill: "#231F20"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M43.625 41.812C42.5894 41.8341 41.3022 41.8137 40.3179 41.7322C40.9001 41.1144 42.9533 41.5029 43.625 41.812Z",
					fill: "#231F20"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M35.4249 45.935C35.5735 47.2197 36.0891 48.5213 36.0244 49.9283C35.4518 50.119 35.1229 50.2858 34.3558 50.2848C34.3016 49.0891 34.1397 47.2612 34.1881 46.1214C34.5655 46.1461 35.1218 45.8552 35.4249 45.935Z",
					fill: "#DCD9D8"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M33.7553 27.002C33.2353 27.3373 32.7924 27.7559 32.293 28.1139C31.1856 28.168 30.5812 28.0382 29.7676 27.41C29.7809 27.3596 29.8627 27.3821 29.8657 27.3202C31.0512 27.8421 32.5582 27.1076 33.7553 27.002Z",
					fill: "#F0D6B7"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M27.532 34.984C27.8577 33.5898 29.1339 32.8678 30.2929 32.1001C31.4891 33.5997 32.2166 35.5282 33.0178 37.3892C31.1249 36.8256 29.1909 35.9111 27.532 34.984Z",
					fill: "#81B0C4"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M34.1883 46.1213C34.1399 47.2611 34.3018 49.089 34.356 50.2847C35.1231 50.2857 35.452 50.1189 36.0246 49.9282C36.0893 48.5213 35.5737 47.2196 35.4251 45.935C35.122 45.8551 34.5657 46.146 34.1883 46.1213ZM22.2427 39.639C22.7486 44.2327 23.4813 48.0942 24.8252 52.162C27.8078 53.0565 31.4034 53.1345 34.0398 52.3273C33.5557 50.0314 33.7672 47.2363 33.4843 44.7863C33.2711 42.9448 33.3797 41.092 33.0874 39.2132C29.893 38.5568 25.3777 39.0598 22.2427 39.639ZM33.8428 39.242C33.8158 41.2149 33.9322 43.161 34.0847 45.1363C34.8516 45.0226 35.3721 44.9467 36.0847 44.7924C35.8533 42.8907 35.8817 40.7508 35.4104 39.0686C34.8656 39.0738 34.386 39.0624 33.8428 39.242ZM37.7334 38.924C37.3694 38.8416 36.9456 38.9208 36.5979 38.9275C36.7613 40.5357 37.158 42.3104 37.2975 43.9985C37.8447 44.0153 38.137 43.7604 38.5871 43.6746C38.6112 42.1928 38.4561 40.1513 37.7334 38.924ZM43.6244 44.2406C44.765 43.967 45.4822 42.5872 45.1632 41.1701C44.9491 40.2177 44.5678 38.4244 44.1598 37.8152C43.8582 37.3645 43.0407 36.7746 42.3879 37.1875C41.326 37.8591 39.4553 38.0541 38.6809 38.8671C39.0692 40.1442 39.1897 41.8982 39.3499 43.5164C40.6765 43.598 42.3088 43.1558 43.4121 43.6251C42.6419 43.8715 41.6424 43.8735 40.9769 44.2327C41.5208 44.4921 42.7942 44.4397 43.6244 44.2406ZM33.018 37.3892C32.2168 35.5282 31.4893 33.5997 30.2931 32.1001C29.1341 32.8679 27.8579 33.5899 27.5322 34.984C29.1911 35.9111 31.1251 36.8256 33.018 37.3892ZM34.9927 31.6263C34.9169 33.4875 34.702 35.9289 34.1997 37.3875C35.3977 35.8808 36.3638 34.1263 37.3736 32.418C36.9432 31.7356 36.0435 31.1406 34.9927 31.6263ZM32.7541 30.8406C32.3003 30.7924 31.9151 31.356 31.325 31.1123C31.1898 31.2599 31.0668 31.4198 30.929 31.564C32.2324 33.1155 32.8247 35.3167 33.8314 37.14C34.3715 35.3886 34.3093 33.4698 34.4283 31.5581C33.6861 31.6047 33.2743 30.8952 32.7541 30.8406ZM31.3147 28.964C31.2662 29.4954 31.3914 29.6692 31.4996 30.2783C33.268 30.8244 32.9592 27.8809 31.3147 28.964ZM29.3537 28.3281C28.5917 27.9169 27.447 27.469 26.4628 27.2835C25.2429 27.053 25.3572 28.9272 25.409 30.0454C25.4496 30.9307 25.9157 31.8668 26.1181 32.4549C26.2131 32.7295 26.2345 33.0209 26.4722 33.0754C26.8924 33.1721 28.2782 32.6248 28.673 32.412C29.5082 31.9622 30.1561 31.248 30.8655 30.7683C30.8747 30.535 30.8836 30.3019 30.8931 30.0686C30.4666 29.8586 29.9738 29.7097 29.3478 29.6826C29.7724 29.4716 30.3972 29.4746 30.7842 29.2235C30.7879 29.13 30.7918 29.0368 30.7951 28.9441C30.0886 28.8904 29.8193 28.5796 29.3537 28.3281ZM22.0756 27.0223C21.4432 27.6565 23.8494 28.521 24.6155 28.5675C24.6112 28.1662 24.847 27.7879 24.7995 27.5C23.8896 27.3422 22.6938 27.4463 22.0756 27.0223ZM29.866 27.3201C29.8629 27.382 29.7812 27.3595 29.7678 27.4099C30.5815 28.0381 31.1858 28.1679 32.2933 28.1138C32.7927 27.7558 33.2356 27.3372 33.7555 27.0019C32.5584 27.1076 31.0515 27.842 29.866 27.3201ZM37.0166 29.4619C36.9824 28.7573 36.7951 27.3084 36.3542 27.0547C35.4288 26.5212 33.7838 28.132 33.087 28.3777C33.1628 28.5933 33.2879 28.764 33.2976 29.0396C33.7097 28.9394 34.2115 29.008 34.5687 29.1813C34.1557 29.227 33.6977 29.224 33.4244 29.4183C33.3243 29.7043 33.449 30.0939 33.3824 30.4908C34.3627 30.764 35.4825 30.9095 36.7219 30.9454C36.9629 30.6359 37.0451 30.0463 37.0166 29.4619ZM21.011 27.6357C20.8124 27.4959 19.469 25.7693 19.2849 25.8409C16.854 26.7879 14.5809 28.4253 12.5497 29.974C14.4863 34.0787 15.2681 39.1076 15.4062 43.9547C17.6247 44.9796 19.5734 46.4571 22.5838 46.6114C22.2355 44.1768 21.9175 42.0047 21.7197 39.7126C20.9633 39.3976 19.8781 39.7268 19.1702 39.6149C19.1642 38.7723 20.2513 39.2459 20.3419 38.6793C20.4101 38.2507 19.7437 38.2182 19.9607 37.5434C20.5141 37.7421 20.8047 38.1809 21.3949 38.3457C21.9342 37.1804 21.3873 35.1185 21.4651 34.1445C21.4798 33.9616 21.5575 33.1313 21.9722 33.277C22.3393 33.4059 21.9513 35.4852 21.9915 36.407C22.0281 37.2563 21.8877 38.0781 22.2359 38.6113C25.1449 38.2202 28.101 37.9674 31.2485 37.8821C30.556 37.5886 29.7334 37.3108 28.8316 36.8087C28.3426 36.5365 26.8015 35.97 26.6604 35.5113C26.4353 34.7804 27.251 34.391 27.3905 33.7644C25.9221 34.5555 25.6356 33.0062 25.2883 31.9086C24.9735 30.9144 24.7944 30.1718 24.7171 29.5984C23.4522 29.0028 22.0998 28.3995 21.011 27.6357ZM35.7319 26.0498C37.7573 25.0797 38.1223 29.6755 37.3284 31.156C37.4511 31.5975 37.8732 31.7666 38.0454 32.1635C36.9152 34.1635 35.6598 36.0303 34.5065 38.0068C35.3644 37.4793 36.5898 37.9124 37.5993 37.5176C37.9683 37.3734 38.2354 36.539 38.5148 35.8715C39.2833 34.035 40.0901 31.7196 40.449 29.967C40.5301 29.5677 40.751 28.6976 40.7015 28.3422C40.6132 27.7058 39.7391 27.234 39.2945 26.8405C38.4754 26.1136 37.9595 25.474 37.1051 24.7944C36.7587 25.2996 36.0152 25.639 35.7319 26.0498ZM16.3789 8.30807C15.4138 9.35697 15.6158 11.3223 15.7326 12.7206C17.4771 11.6366 19.7925 12.8063 19.7707 14.65C20.6035 14.6281 20.0818 13.6225 19.9312 12.9747C19.4388 10.8587 20.7606 8.5598 19.9911 6.62476C18.497 6.73666 17.2695 7.33947 16.3789 8.30807ZM23.2844 2.22028C21.0996 2.83196 18.2994 4.40012 17.4016 6.33883C18.0968 6.23905 18.5794 5.89274 19.2652 5.84988C19.5244 5.83321 19.864 5.95724 20.1619 5.88408C20.7555 5.73863 21.2565 4.42393 21.7043 3.93476C22.1409 3.45706 22.6656 3.25295 23.0246 2.81746C23.2553 2.70751 23.5964 2.71508 23.6095 2.37288C23.5096 2.26725 23.4043 2.18673 23.2844 2.22028ZM34.6579 2.7956C32.3902 1.53176 28.5517 0.581129 26.1394 1.76899C24.1929 2.72763 21.5618 4.31376 20.6647 6.32368C21.5027 8.26326 20.4165 10.0405 20.3472 12.0097C20.3104 13.0576 20.8466 13.9723 20.8877 15.1129C20.601 15.5803 19.7249 15.6378 19.1184 15.6058C18.9143 14.5967 18.5569 13.4625 17.5049 13.3487C16.0164 13.1879 14.928 14.4047 14.8604 15.6764C14.7804 17.1718 16.0232 19.6503 17.7848 19.4782C18.4653 19.4118 18.6325 18.738 19.3739 18.7449C19.7758 19.5369 18.754 19.7856 18.6489 20.352C18.6215 20.4984 18.7337 21.0702 18.7989 21.3384C19.1189 22.6442 19.8321 24.3342 20.5342 25.3284C21.4253 26.5894 23.1759 26.7794 25.0593 26.903C25.3957 26.1872 26.6349 26.2461 27.4423 26.4333C26.4746 26.0548 25.575 25.137 24.8295 24.3247C23.9731 23.3927 23.1055 22.3929 23.0617 21.1748C24.6801 23.3925 26.0171 25.3292 28.96 26.3048C31.1867 27.0424 33.7873 25.9667 35.4983 24.7799C36.2082 24.2866 36.632 23.5039 37.1367 22.7875C39.0249 20.1046 39.906 16.2753 39.7123 12.5636C39.6326 11.0329 39.6361 9.5074 39.1161 8.47754C38.5726 7.40072 36.7346 6.43732 35.6587 7.41133C35.4593 6.36416 36.5534 5.71655 37.8386 6.09338C36.9222 4.92522 35.9604 3.52156 34.6579 2.7956ZM38.8829 37.3334C40.655 36.4632 43.9661 34.9912 45.077 37.3366C45.487 38.2012 45.968 39.6626 46.1803 40.555C46.4803 41.814 45.8552 44.4604 44.545 44.8828C43.3878 45.256 42.0375 45.2332 40.6436 44.9567C40.4795 44.8218 40.2967 44.5867 40.169 44.3417C39.1737 44.3036 38.2418 44.3945 37.4555 44.7986C37.53 45.5257 37.0322 45.6424 36.5654 45.7921C36.2194 47.1473 37.2577 48.917 37.0092 50.1527C36.8319 51.033 35.7354 51.1691 34.9294 51.3338C34.9031 51.823 34.9647 52.2314 35.0197 52.6453C34.8354 53.316 34.0089 53.6978 33.2257 53.7913C30.649 54.0974 26.7366 54.2349 24.2581 53.3545C23.5665 51.6789 23.0216 49.6408 22.4456 47.7274C20.0283 47.9823 18.0733 46.6971 16.2302 45.8551C15.5921 45.5629 14.7093 45.4019 14.4709 44.9002C14.2398 44.4144 14.3344 43.4835 14.2771 42.6041C14.1311 40.358 14.0061 38.1916 13.4057 35.8918C13.1361 34.8598 12.6661 33.9492 12.3383 32.9549C12.0353 32.0332 11.5058 30.8943 11.3678 29.9753C11.163 28.6132 12.4615 28.5374 13.2918 27.9472C14.5754 27.0344 15.5828 26.5296 16.9729 25.7058C17.3846 25.4619 18.6263 24.8444 18.7675 24.56C19.0482 23.9961 18.2856 23.2011 18.0817 22.7591C17.7591 22.0602 17.5909 21.4665 17.5447 20.7769C16.3786 20.5949 15.4947 19.9094 14.9607 19.1365C14.0775 17.8573 13.4649 15.4906 14.2291 13.6905C14.289 13.5487 14.5879 13.2699 14.632 13.0521C14.719 12.6234 14.4684 12.0532 14.4528 11.5972C14.3725 9.2574 14.8536 7.24141 16.4482 6.5358C17.0956 3.98843 19.4126 3.14148 21.5956 1.87548C22.4116 1.40233 23.3111 1.09995 24.2401 0.762295C27.5727 -0.449158 32.6858 -0.221022 35.4516 1.84518C36.6244 2.72136 38.499 4.57133 39.1696 5.9107C40.9405 9.44679 40.8148 15.3564 39.576 19.6579C39.4095 20.2354 39.168 21.0843 38.8308 21.778C38.5957 22.2624 37.8649 23.2316 37.9536 23.6593C38.045 24.1015 39.6199 25.2827 39.9575 25.6043C40.5656 26.1838 41.7209 26.9528 41.8144 27.684C41.915 28.4621 41.4673 29.5266 41.2405 30.2774C40.4824 32.7832 39.7426 35.0995 38.8829 37.3334Z",
					fill: "#231F20"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M27.0601 19.9877C27.1563 19.8613 27.6848 19.6693 28.4244 20.021C28.4244 20.021 27.5479 20.1654 27.6208 21.6089L27.2555 21.5366C27.2555 21.5366 26.8781 20.2277 27.0601 19.9877Z",
					fill: "#F7E4CD"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M33.4642 32.3948C33.4642 32.6139 33.2843 32.7915 33.0623 32.7915C32.8405 32.7915 32.6606 32.6139 32.6606 32.3948C32.6606 32.1758 32.8405 31.9978 33.0623 31.9978C33.2843 31.9978 33.4642 32.1758 33.4642 32.3948Z",
					fill: "#1D1919"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M33.8663 34.2346C33.8663 34.4537 33.6864 34.6313 33.4644 34.6313C33.2426 34.6313 33.0627 34.4537 33.0627 34.2346C33.0627 34.0156 33.2426 33.8377 33.4644 33.8377C33.6864 33.8377 33.8663 34.0156 33.8663 34.2346Z",
					fill: "#1D1919"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_113679_682",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 39.6184,
				height: 54.0251,
				fill: "white",
				transform: "translate(7.23096)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgJenkinsLogo);
export { ForwardRef as ReactComponent };
